module.exports = __webpack_public_path__ + "static/media/LogicWedge5_3_2.b0d63074.png";